import { render, staticRenderFns } from "./notDetail.vue?vue&type=template&id=57bd995e&scoped=true"
import script from "./notDetail.vue?vue&type=script&lang=js"
export * from "./notDetail.vue?vue&type=script&lang=js"
import style0 from "./notDetail.vue?vue&type=style&index=0&id=57bd995e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bd995e",
  null
  
)

export default component.exports